import ApartmentIcon from '@mui/icons-material/Apartment'
import { Tooltip } from '@mui/material'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom-v5-compat'
import { TextV2 } from 'shared/components/Text/TextV2'
import { useBreakpoint } from 'shared/hooks/useBreakpoint'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

import { useOrganization } from '../../../hooks/query/useOrganization'
import { currentTeamSelector } from '../../../redux/selectors/team'
import { currentUserSelector, isVendorUserSelector } from '../../../redux/selectors/users'
import { FLEET_PROFILE_PATH, PROFILE_PATH } from '../../../Routes'
import { useLayoutContext } from '../../Context/LayoutContext'
import { useCompanyBranding } from './useCompanyBranding'

export function SideBarHeader() {
  const isVendorUser = useSelector(isVendorUserSelector)
  const user = useSelector(currentUserSelector)
  const team = useSelector(currentTeamSelector)
  const { data: organization } = useOrganization()
  const { isSideBarCollapsed, setIsSideBarCollapsed } = useLayoutContext()
  const branding = useCompanyBranding()
  const [failedImage, setFailedImage] = useState('')
  const logo = branding?.sidebarLogoUrl || branding?.logoUrl
  const isMobile = useBreakpoint('xs')
  const isCompany = Boolean(user.organization && !isVendorUser)
  const name = user.is_staff
    ? 'CloudTrucks'
    : isVendorUser
      ? user.vendor_membership?.vendor.legal_business_name
      : isCompany
        ? organization?.name || branding?.name || 'Your company'
        : team.name
  const companyLabel = `${name} — ${user.can_operate_fleet ? 'Company' : 'My profile'}`
  const accessibleName = isCompany ? companyLabel : name
  if (isCompany && isSideBarCollapsed) return null
  return (
    <Tooltip title={isSideBarCollapsed ? name || 'Company' : ''} placement="right">
      <Link
        to={
          user.is_staff
            ? '/manage/organizations'
            : user.can_operate_fleet
              ? '/manage/company/'
              : isCompany
                ? PROFILE_PATH
                : FLEET_PROFILE_PATH
        }
        aria-label={accessibleName}
        onClick={() => {
          if (isMobile) setIsSideBarCollapsed(true)
        }}
        className="flex min-h-10 items-center gap-3 rounded-lg px-2 py-1 text-inherit no-underline focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        {!isCompany && (
          <div className="bg-royal-blue/8 text-royal-blue flex size-9 shrink-0 items-center justify-center rounded-lg">
            <ApartmentIcon fontSize="small" />
          </div>
        )}
        {!isSideBarCollapsed && (
          <div className="min-w-0">
            <div className="flex min-w-0 items-center gap-2">
              {isCompany && !user.is_staff && logo && failedImage !== logo && (
                <img
                  src={logo}
                  alt={`${name} logo`}
                  onError={() => setFailedImage(logo)}
                  className="size-10 shrink-0 object-contain"
                />
              )}
              <TextV2 type={TYPOGRAPHY.label2} className="line-clamp-2 min-w-0 font-semibold break-words">
                {name}
              </TextV2>
            </div>
            {(!isCompany || user.is_staff) && (
              <TextV2 type={TYPOGRAPHY.paragraph3} className="text-mid-gray">
                {user.is_staff ? 'Staff' : 'Fleet'}
              </TextV2>
            )}
          </div>
        )}
      </Link>
    </Tooltip>
  )
}
